import "core-js/modules/es.array.reduce.js";
import "core-js/modules/esnext.global-this.js";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";

function _createForOfIteratorHelperLoose(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (it) return (it = it.call(o)).next.bind(it);

  if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
    if (it) o = it;
    var i = 0;
    return function () {
      if (i >= o.length) return {
        done: true
      };
      return {
        done: false,
        value: o[i++]
      };
    };
  }

  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

import "core-js/modules/es.array.reduce.js";
import "core-js/modules/esnext.global-this.js";
import { CoreEvent, eventNames, useCoreEvents } from '@carvana/core-events';
import { useEffect, useRef, useCallback } from 'react';
import { useSyncExternalStore } from 'use-sync-external-store/shim';
/*! @carvana/core-auth v1.1.5 - Mon Jul 31 2023 20:56:02 GMT+0000 (Coordinated Universal Time) */

var wait = function wait(ms) {
  return new Promise(function (resolve) {
    return setTimeout(resolve, ms);
  });
};

var isSSR = function isSSR() {
  var _a2;

  return !(typeof window !== "undefined" && ((_a2 = window.document) == null ? void 0 : _a2.createElement));
};

var isFunction = function isFunction(fn) {
  return fn instanceof Function;
};

var Cookies = {
  get: function get(name, _temp) {
    var _ref = _temp === void 0 ? {} : _temp,
        cookieStore = _ref.cookieStore,
        req = _ref.req;

    try {
      if (cookieStore && isFunction(cookieStore)) {
        return cookieStore().get(name);
      }

      var cookieString = req ? req.headers.cookie : document.cookie;
      var cookies = cookieString ? cookieString.split("; ").reduce(function (accumulator, currentCookie) {
        var _currentCookie$split = currentCookie.split("="),
            key = _currentCookie$split[0],
            value = _currentCookie$split[1];

        accumulator[key] = value;
        return accumulator;
      }, {}) : {};
      return cookies[name];
    } catch (error) {
      return "";
    }
  },
  remove: function remove(name, _temp2) {
    var _ref2 = _temp2 === void 0 ? {} : _temp2,
        cookieStore = _ref2.cookieStore,
        res = _ref2.res;

    try {
      if (cookieStore && isFunction(cookieStore)) {
        cookieStore().set(name, "", {
          expires: new Date("1970-01-01"),
          path: "/"
        });
        return;
      }

      if (!isSSR()) {
        document.cookie = name + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
      } else if (res) {
        res.setHeader("Set-Cookie", name + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;");
      }
    } catch (error) {}
  },
  set: function set(name, value, options, res) {
    if (options === void 0) {
      options = {};
    }

    try {
      var _options = options,
          maxAge = _options.maxAge,
          path = _options.path,
          domain = _options.domain,
          secure = _options.secure,
          httpOnly = _options.httpOnly;
      var cookieString = encodeURIComponent(name) + "=" + encodeURIComponent(value);

      if (maxAge) {
        cookieString += "; Max-Age=" + maxAge;
      }

      if (domain) {
        cookieString += "; Domain=" + domain;
      }

      if (path) {
        cookieString += "; Path=" + path;
      } else {
        cookieString += "; Path=/";
      }

      if (secure) {
        cookieString += "; Secure";
      }

      if (httpOnly) {
        cookieString += "; HttpOnly";
      }

      if (!isSSR()) {
        document.cookie = cookieString;
      } else if (res) {
        res.setHeader("Set-Cookie", cookieString);
      }
    } catch (error) {}
  }
};

var base64UrlDecode = function base64UrlDecode(base64Url) {
  var base64 = base64Url.replace("-", "+").replace("_", "/");
  var padLength = 4 - base64.length % 4;
  var padding = padLength < 4 ? "=".repeat(padLength) : "";

  if (isSSR()) {
    return Buffer.from(base64 + padding, "base64").toString("utf8");
  } else {
    return atob(base64 + padding);
  }
};

var decodeJWT = function decodeJWT(token) {
  try {
    var _token$split = token.split("."),
        _ = _token$split[0],
        payload = _token$split[1],
        __ = _token$split[2];

    var decodedPayload = JSON.parse(base64UrlDecode(payload));
    return decodedPayload;
  } catch (error) {
    console.error("Error decoding JWT:", error);
    return {};
  }
};

var urls = new Map();
var exclusions = [{
  type: "purchase-process",
  func: function func() {
    var _a2;

    var _ref3 = !isSSR() ? window.location : {
      pathname: ""
    },
        pathname = _ref3.pathname;

    return (_a2 = pathname == null ? void 0 : pathname.toLowerCase()) == null ? void 0 : _a2.startsWith("/purchase");
  }
}, {
  type: "refresh-token",
  func: function func(input) {
    var _a2, _b;

    return ((_a2 = input == null ? void 0 : input.toLowerCase()) == null ? void 0 : _a2.includes("postrequestfornewtoken")) || ((_b = input == null ? void 0 : input.toLowerCase()) == null ? void 0 : _b.includes("refresh-token"));
  }
}];
var interceptionUrls = ["carvana.com", "carvana.io", "zagforward.com", "carvanatech.com"];

var isRequestURLInInterceptionList = function isRequestURLInInterceptionList(url) {
  return !!interceptionUrls.find(function (x) {
    var _a2;

    return (_a2 = url == null ? void 0 : url.toLowerCase()) == null ? void 0 : _a2.includes(x == null ? void 0 : x.toLowerCase());
  });
};

var isFileUrl = function isFileUrl(url) {
  var fileExtensionPattern = /(\.[a-zA-Z0-9]+)(\?|#|$)/;
  var lastSlashIndex = url.lastIndexOf("/");
  var match = fileExtensionPattern.exec(url);

  if (match && match.index > lastSlashIndex) {
    return true;
  }

  return false;
};

var isEndpointUrl = function isEndpointUrl(url) {
  return !isFileUrl(url);
};

var random = function random(min, max) {
  return Math.floor(Math.random() * (max - min + 1) + min);
};

var _a;

if (!isSSR()) {
  window.Carvana = Object.assign({}, (window == null ? void 0 : window.Carvana) || {}, {
    interceptor: Object.assign({}, ((_a = window == null ? void 0 : window.Carvana) == null ? void 0 : _a.interceptor) || {}, {
      addExclusion: function addExclusion(type, func) {
        exclusions.push({
          type: type,
          func: func
        });
      }
    })
  });
}

var isTestEnvironment = function isTestEnvironment() {
  return (globalThis == null ? void 0 : globalThis.CARVANA_ENVIRONMENT) && (globalThis == null ? void 0 : globalThis.CARVANA_ENVIRONMENT) === "test";
};

var fetchAuthToken = function fetchAuthToken(type, axios) {
  var authTokenUrl = "/refresh-token";

  if (type === "axios") {
    if (axios) {
      return axios({
        method: "POST",
        baseURL: "",
        url: authTokenUrl,
        headers: {
          "Content-Type": "application/json"
        }
      });
    }

    return import('axios').then(function (r) {
      var _ref4 = (r == null ? void 0 : r.default) || r,
          post = _ref4.post;

      return post(authTokenUrl, {
        headers: {
          "Content-Type": "application/json"
        }
      });
    });
  }

  return monkeyPatchedFetch(authTokenUrl, {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    mode: "cors"
  });
};

var getCvAccessToken = function getCvAccessToken(_temp3) {
  var _ref5 = _temp3 === void 0 ? {} : _temp3,
      cookieStore = _ref5.cookieStore,
      req = _ref5.req;

  var _a2;

  var CVAccessToken = Cookies.get("CVAccessToken", {
    req: req,
    cookieStore: cookieStore
  }) || "";

  if (CVAccessToken) {
    var token = "";

    try {
      token = ((_a2 = JSON.parse(CVAccessToken)) == null ? void 0 : _a2["access_token"]) || CVAccessToken;
    } catch (error) {
      token = CVAccessToken;
    }

    return token;
  }

  return "";
};

var authorizationHeader = function authorizationHeader() {
  var accessToken2 = getCvAccessToken();
  var scheme = "Bearer";
  return {
    Authorization: scheme + " " + accessToken2
  };
};

var OriginalFetch = isSSR() ? globalThis == null ? void 0 : globalThis.fetch : window.fetch;

var handleResponse = /*#__PURE__*/function () {
  var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(request, input, init) {
    var _a2, _b, _iterator, _step, exclusion, response, url, status, urlRetryCount, refresh, newResponse;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!(isSSR() || !isSSR() && ((_b = (_a2 = window == null ? void 0 : window.Carvana) == null ? void 0 : _a2.interceptor) == null ? void 0 : _b.disabled))) {
              _context.next = 2;
              break;
            }

            return _context.abrupt("return", request);

          case 2:
            _iterator = _createForOfIteratorHelperLoose(exclusions);

          case 3:
            if ((_step = _iterator()).done) {
              _context.next = 9;
              break;
            }

            exclusion = _step.value;

            if (!exclusion.func(input)) {
              _context.next = 7;
              break;
            }

            return _context.abrupt("return", request);

          case 7:
            _context.next = 3;
            break;

          case 9:
            _context.next = 11;
            return request;

          case 11:
            response = _context.sent;
            url = response.url, status = response.status;
            urlRetryCount = urls.get(url) || 0;

            if (!(status === 401 && isRequestURLInInterceptionList(url) && urlRetryCount <= 2)) {
              _context.next = 31;
              break;
            }

            urls.set(url, urlRetryCount + 1);

            if (!(urlRetryCount >= 0)) {
              _context.next = 19;
              break;
            }

            _context.next = 19;
            return wait(urlRetryCount * random(500, 1e3));

          case 19:
            _context.next = 21;
            return fetchAuthToken("fetch").catch(function (err) {
              console.error("there was an error trying to get access token", err);
              return request;
            });

          case 21:
            refresh = _context.sent;

            if (!refresh.ok) {
              _context.next = 31;
              break;
            }

            _context.next = 25;
            return fetch(input, Object.assign({}, init, {
              headers: Object.assign({}, init == null ? void 0 : init.headers, authorizationHeader())
            }));

          case 25:
            newResponse = _context.sent;

            if (!newResponse.ok) {
              _context.next = 30;
              break;
            }

            urls.delete(url);
            CoreEvent.emit(eventNames.auth.tokenRefreshed);
            return _context.abrupt("return", newResponse);

          case 30:
            return _context.abrupt("return", response);

          case 31:
            return _context.abrupt("return", request);

          case 32:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function handleResponse(_x, _x2, _x3) {
    return _ref6.apply(this, arguments);
  };
}();

var monkeyPatchedFetch = /*#__PURE__*/function () {
  var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(input, init) {
    var modifiedInit;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            modifiedInit = Object.assign({}, init);

            if (isTestEnvironment()) {
              modifiedInit.credentials = "include";
            }

            if (isRequestURLInInterceptionList(input) && isEndpointUrl(input)) {
              modifiedInit.headers = Object.assign({}, modifiedInit.headers, authorizationHeader());
            }

            return _context2.abrupt("return", handleResponse(OriginalFetch(input, modifiedInit), input, modifiedInit));

          case 4:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function monkeyPatchedFetch(_x4, _x5) {
    return _ref7.apply(this, arguments);
  };
}();

if (!isSSR()) {
  window.fetch = monkeyPatchedFetch;
}

var setupAxios = function setupAxios(axios, opts) {
  var axiosAuth = axios;

  var _ref8 = opts || {
    addBearerTokenToAllRequests: true
  },
      addBearerTokenToAllRequests = _ref8.addBearerTokenToAllRequests;

  var handleRequest = function handleRequest(config) {
    var originalConfig = config;

    if (addBearerTokenToAllRequests) {
      var _authorizationHeader = authorizationHeader(),
          Authorization = _authorizationHeader.Authorization;

      if (Authorization) {
        originalConfig.headers.Authorization = Authorization;
      }
    }

    if (isTestEnvironment()) {
      originalConfig.withCredentials = true;
    }

    return originalConfig;
  };

  var handleResponse2 = function handleResponse2(response) {
    return response;
  };

  var handleError = /*#__PURE__*/function () {
    var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(error) {
      var _a2, _iterator2, _step2, exclusion, originalRequest, ogUrl, baseURL, url, urlRetryCount, refresh, _authorizationHeader2, Authorization, newResponse;

      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              if (!(error && error.config && error.response)) {
                _context3.next = 30;
                break;
              }

              _iterator2 = _createForOfIteratorHelperLoose(exclusions);

            case 2:
              if ((_step2 = _iterator2()).done) {
                _context3.next = 8;
                break;
              }

              exclusion = _step2.value;

              if (!exclusion.func(((_a2 = error == null ? void 0 : error.config) == null ? void 0 : _a2.url) || "")) {
                _context3.next = 6;
                break;
              }

              return _context3.abrupt("return", Promise.reject(error));

            case 6:
              _context3.next = 2;
              break;

            case 8:
              originalRequest = error.config;
              ogUrl = originalRequest.url, baseURL = originalRequest.baseURL;
              url = baseURL || ogUrl || "";
              urlRetryCount = urls.get(url) || 0;

              if (!(error.response.status === 401 && isRequestURLInInterceptionList(url) && urlRetryCount <= 2)) {
                _context3.next = 30;
                break;
              }

              urls.set(url, urlRetryCount + 1);

              if (!(urlRetryCount >= 0)) {
                _context3.next = 17;
                break;
              }

              _context3.next = 17;
              return wait(urlRetryCount * random(500, 1e3));

            case 17:
              _context3.next = 19;
              return fetchAuthToken("axios", axios).catch(function () {
                return Promise.reject(error);
              });

            case 19:
              refresh = _context3.sent;

              if (!refresh) {
                _context3.next = 30;
                break;
              }

              _authorizationHeader2 = authorizationHeader(), Authorization = _authorizationHeader2.Authorization;

              if (Authorization) {
                originalRequest.headers.Authorization = Authorization;
              }

              _context3.next = 25;
              return axios(originalRequest);

            case 25:
              newResponse = _context3.sent;

              if (!newResponse) {
                _context3.next = 30;
                break;
              }

              urls.delete(url);
              CoreEvent.emit(eventNames.auth.tokenRefreshed);
              return _context3.abrupt("return", newResponse);

            case 30:
              return _context3.abrupt("return", Promise.reject(error));

            case 31:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function handleError(_x6) {
      return _ref9.apply(this, arguments);
    };
  }();

  axiosAuth.interceptors.request.use(handleRequest);
  axiosAuth.interceptors.response.use(handleResponse2, handleError);
  return axiosAuth;
};

var cookieNameCVIdToken = "CVIdToken";
var cookieNameCVAccessToken = "CVAccessToken";

var accessToken = function accessToken(_temp4) {
  var _ref10 = _temp4 === void 0 ? {} : _temp4,
      cookieStore = _ref10.cookieStore,
      req = _ref10.req;

  var _a2, _b;

  var CVIdToken = Cookies.get(cookieNameCVIdToken, {
    cookieStore: cookieStore,
    req: req
  }) || "";
  var CVAccessToken = getCvAccessToken({
    cookieStore: cookieStore,
    req: req
  });
  var hasIdTokenAndAccessToken = !!CVIdToken && !!CVAccessToken;
  var hasAccessTokenAndNoIdToken = !CVIdToken && !!CVAccessToken;

  if (hasIdTokenAndAccessToken || hasAccessTokenAndNoIdToken) {
    var jwt = hasIdTokenAndAccessToken ? decodeCookie(CVIdToken) : decodeCookie(CVAccessToken);
    var token = hasIdTokenAndAccessToken ? cookieNameCVIdToken : cookieNameCVAccessToken;
    return {
      token: token,
      jwt: jwt,
      isValidToken: !!jwt && Object.keys(jwt).length > 0,
      isLoggedIn: !!(jwt == null ? void 0 : jwt.user_id),
      user: {
        email: jwt == null ? void 0 : jwt.email,
        name: jwt == null ? void 0 : jwt.name,
        user_id: jwt == null ? void 0 : jwt.user_id,
        given_name: jwt == null ? void 0 : jwt.given_name,
        family_name: jwt == null ? void 0 : jwt.family_name,
        sub: jwt == null ? void 0 : jwt.sub,
        is_new_3p: !(jwt == null ? void 0 : jwt.is_user_new) || (jwt == null ? void 0 : jwt.is_user_new) === void 0 ? false : ((_a2 = jwt == null ? void 0 : jwt.is_user_new) == null ? void 0 : _a2.toLowerCase()) === "false" ? false : true
      },
      impersonation: {
        impersonating_user: jwt == null ? void 0 : jwt.impersonating_user,
        is_impersonating: !(jwt == null ? void 0 : jwt.is_impersonating) || (jwt == null ? void 0 : jwt.is_impersonating) === void 0 ? false : ((_b = jwt == null ? void 0 : jwt.is_impersonating) == null ? void 0 : _b.toLowerCase()) === "false" ? false : true
      },
      cvIdToken: CVIdToken,
      cvAccessToken: CVAccessToken
    };
  }

  return {
    token: "MISSING",
    jwt: {},
    isValidToken: false,
    isLoggedIn: false,
    user: {},
    impersonation: {},
    cvIdToken: CVIdToken,
    cvAccessToken: CVAccessToken
  };
};

var decodeCookie = function decodeCookie(accessToken2) {
  try {
    var jwt = decodeJWT(accessToken2);
    return jwt;
  } catch (error) {
    return {};
  }
};

var createLogoutIframe = function createLogoutIframe() {
  if (isSSR()) {
    return Promise.resolve(null);
  }

  return new Promise(function (resolve) {
    try {
      var ifrm = document.createElement("iframe");
      ifrm.setAttribute("src", "/account/thirdpartylogout");
      ifrm.setAttribute("id", "cvna-auth-logout");
      ifrm.style = "position: absolute;width:0;height:0;border:0;";
      document.body.appendChild(ifrm);
      ifrm.addEventListener("load", function () {
        setTimeout(function () {
          ifrm.remove();
          return resolve(null);
        }, 500);
      });
    } catch (error) {
      return resolve(null);
    }
  });
};

var deepEqual = function deepEqual(object1, object2) {
  var keys1 = Object.keys(object1);
  var keys2 = Object.keys(object2);

  if (keys1.length !== keys2.length) {
    return false;
  }

  for (var _i = 0, _keys = keys1; _i < _keys.length; _i++) {
    var key = _keys[_i];
    var val1 = object1[key];
    var val2 = object2[key];
    var areObjects = isObject(val1) && isObject(val2);

    if (areObjects && !deepEqual(val1, val2) || !areObjects && val1 !== val2) {
      return false;
    }
  }

  return true;
};

var isObject = function isObject(object) {
  return object !== null && typeof object === "object";
};

var merge = function merge(obj, defaultObj) {
  if (defaultObj === void 0) {
    defaultObj = {};
  }

  var mergedObj = Object.assign({}, defaultObj, obj);

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      if (typeof obj[key] === "boolean") {
        mergedObj[key] = obj[key];
      }
    }
  }

  return mergedObj;
};

var defaultAuthStoreOpts = {
  name: "core-auth",
  debug: false,
  refreshTokenIfExpiredOnFirstLoad: true
};

var authStore = function authStore(initialState, opts) {
  var userState = initialState;
  var subscribers = new Set();

  var _merge = merge(opts, defaultAuthStoreOpts),
      name = _merge.name,
      debug = _merge.debug;

  var onUserStateChange = function onUserStateChange() {
    updateUserState(accessToken());
  };

  CoreEvent.on(eventNames.auth.login, function () {
    CoreEvent.emit(eventNames.auth.change, accessToken(), {
      debug: debug,
      name: name
    });
  }, {
    debug: debug,
    name: name
  });
  CoreEvent.on(eventNames.auth.change, onUserStateChange, {
    debug: debug,
    name: name
  });

  var onUserLogout = /*#__PURE__*/function () {
    var _ref11 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(cb) {
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return createLogoutIframe().catch(function () {});

            case 2:
              _context4.next = 4;
              return fetch("/user-logout", {
                method: "POST",
                mode: "cors",
                headers: {
                  "Content-Type": "application/json"
                }
              }).catch(function () {
                for (var _i2 = 0, _arr = ["CVAccessToken", "CVIdToken"]; _i2 < _arr.length; _i2++) {
                  var token = _arr[_i2];

                  try {
                    Cookies.remove(token);
                  } catch (error) {
                    console.error("unable to delete cookies", error);
                  }
                }
              });

            case 4:
              if (!deepEqual(accessToken(), getSnapshot())) {
                CoreEvent.emit(eventNames.auth.change, accessToken(), {
                  debug: debug,
                  name: name
                });
              }

              cb == null ? void 0 : cb();

            case 6:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function onUserLogout(_x7) {
      return _ref11.apply(this, arguments);
    };
  }();

  CoreEvent.on(eventNames.auth.logout, onUserLogout, {
    debug: debug,
    name: name
  });

  var onUserRefresh = /*#__PURE__*/function () {
    var _ref12 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(cb) {
      var response;
      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return fetchAuthToken("fetch").catch(function () {});

            case 2:
              response = _context5.sent;

              if ((response == null ? void 0 : response.ok) && !deepEqual(accessToken(), getSnapshot())) {
                CoreEvent.emit(eventNames.auth.change, accessToken(), {
                  debug: debug,
                  name: name
                });
              }

              cb == null ? void 0 : cb();

            case 5:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));

    return function onUserRefresh(_x8) {
      return _ref12.apply(this, arguments);
    };
  }();

  CoreEvent.on(eventNames.auth.refresh, onUserRefresh, {
    debug: debug,
    name: name
  });
  CoreEvent.on(eventNames.auth.tokenRefreshed, function () {
    return CoreEvent.emit(eventNames.auth.change, accessToken(), {
      debug: debug,
      name: name
    });
  });

  var getSnapshot = function getSnapshot() {
    return userState;
  };

  var subscribe = function subscribe(callback) {
    subscribers.add(callback);
    return function () {
      return subscribers.delete(callback);
    };
  };

  var updateUserState = function updateUserState(state) {
    userState = Object.assign({}, state);
    subscribers.forEach(function (cb) {
      return cb();
    });
  };

  return {
    getSnapshot: getSnapshot,
    subscribe: subscribe,
    updateUserState: updateUserState,
    onUserLogout: onUserLogout
  };
};

var Singleton = /*#__PURE__*/function () {
  function Singleton(config, opts) {
    return authStore(config, opts);
  }

  Singleton.getInstance = function getInstance(config, opts) {
    if (!Singleton.instance) {
      Singleton.instance = new Singleton(config, opts);
    }

    return Singleton.instance;
  };

  return Singleton;
}();

var AuthStore = Singleton.getInstance;

var getUserState = function getUserState(props) {
  try {
    var at = accessToken();
    AuthStore(at, props);
    return at;
  } catch (error) {
    return accessToken();
  }
};

var logoutUser = function logoutUser(cb) {
  CoreEvent.emit(eventNames.auth.logout, cb);
};

var refreshUserToken = function refreshUserToken(cb) {
  CoreEvent.emit(eventNames.auth.refresh, cb);
};

var useCoreAuth = function useCoreAuth(props) {
  if (props === void 0) {
    props = {};
  }

  var opts = merge(props, defaultAuthStoreOpts);
  var name = opts.name,
      debug = opts.debug,
      refreshTokenIfExpiredOnFirstLoad = opts.refreshTokenIfExpiredOnFirstLoad;
  var store = AuthStore(accessToken(), opts);
  useSyncExternalStore(store.subscribe, store.getSnapshot);
  useEffect(function () {
    var _store$getSnapshot = store.getSnapshot(),
        cvAccessToken = _store$getSnapshot.cvAccessToken,
        cvIdToken = _store$getSnapshot.cvIdToken,
        isValidToken = _store$getSnapshot.isValidToken;

    if (cvIdToken && !cvAccessToken && !isValidToken && refreshTokenIfExpiredOnFirstLoad) {
      refreshUserToken();
    }
  }, []);
  var onUserStateChangeRef = useRef();
  var onUserStateChange = useCallback(function (a) {
    onUserStateChangeRef.current = a;
  }, []);

  var stateChange = function stateChange() {
    var _a2;

    (_a2 = onUserStateChangeRef == null ? void 0 : onUserStateChangeRef.current) == null ? void 0 : _a2.call(onUserStateChangeRef, getUserState());
  };

  useCoreEvents(eventNames.auth.change, stateChange, {
    debug: debug,
    name: name
  });
  var logoutUser2 = useRef(function (cb) {
    CoreEvent.emit(eventNames.auth.logout, cb, {
      debug: debug,
      name: name
    });
  });
  var refreshUser = useRef(function (cb) {
    CoreEvent.emit(eventNames.auth.refresh, cb, {
      debug: debug,
      name: name
    });
  });
  return {
    logoutUser: logoutUser2.current,
    onUserStateChange: onUserStateChange,
    getUserState: getUserState,
    refreshUser: refreshUser.current
  };
}; //! future url


export { AuthStore, accessToken, defaultAuthStoreOpts, getCvAccessToken, getUserState, logoutUser, refreshUserToken, setupAxios, useCoreAuth };